var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeachWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1922_4444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8344 14.2671C13.4437 13.8766 13.4437 13.2433 13.8343 12.8527L13.8497 12.8373C14.2403 12.4467 14.8736 12.4467 15.2641 12.8374L20.2902 17.8659C20.6806 18.2564 20.6739 18.896 20.2835 19.2865C19.893 19.6769 19.2534 19.6836 18.8629 19.2932L13.8344 14.2671ZM16.6848 7.15194C17.1057 7.5095 17.7366 7.5134 18.1271 7.12287L19.5729 5.67709C19.9634 5.28656 19.9661 4.64881 19.5395 4.29814C15.5667 1.03315 9.6917 1.24766 5.97998 4.94998C9.61104 3.74887 13.6262 4.55384 16.6848 7.15194ZM5.94998 4.97998C2.24766 8.6917 2.03315 14.5667 5.29814 18.5395C5.64881 18.9661 6.28656 18.9634 6.67709 18.5729L8.12287 17.1271C8.5134 16.7366 8.5095 16.1057 8.15194 15.6848C5.55384 12.6262 4.74887 8.61104 5.94998 4.97998ZM5.96998 4.95998L5.95998 4.96998C5.60891 7.75084 6.90517 11.2657 9.57277 14.2609C9.94051 14.6738 10.5773 14.6727 10.9682 14.2817L15.2829 9.96709C15.6734 9.57656 15.675 8.94067 15.263 8.5729C12.2744 5.90521 8.75088 4.6089 5.96998 4.95998Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1922_4444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachWhite);
export default __webpack_public_path__ + "static/media/beach-white.72e206b55e1caa50d295eefde9c8d60c.svg";
export { ForwardRef as ReactComponent };